import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function GuiaTamanhosHoobuy() {
  return <ArticleLayout article={newArticles[4]} />;
}